import classNames from 'classnames';
import styles from './FooterCard.module.scss';
import { UI_Heading } from 'ui/components/1-atoms/Heading/Heading';
import { UI_Link } from 'ui/components/1-atoms/Action/Link/Link';
import { UI_Icon } from 'ui/components/1-atoms/Media/Icon/Icon';
import UI_Chevron from 'ui/icons/icon-chevron-down.svg';
import { UI_RichText } from 'ui/components/1-atoms/RichText/RichText';

export interface FooterCardProps {
	className?: string;
	heading?: string;
	text?: string;
	links?: {
		url: string;
		target?: string;
		name?: string;
	}[];
}

export const UI_FooterCard = ({ className, heading, text, links }: FooterCardProps) => (
	<div className={classNames(styles.FooterCard, className)}>
		<div className={styles.FooterCard_textbox}>
			{heading && (
				<UI_Heading headingLevel="h3" style="sm" className={styles.FooterCard_heading}>
					{heading}
				</UI_Heading>
			)}
			{text && <UI_RichText linkColor="light" className={styles.FooterCard_text} content={text} />}
		</div>
		{links?.length ? (
			<div className={styles.FooterCard_links}>
				{links?.map((link, index) => (
					<UI_Link key={index} className={styles.FooterCard_link} url={link?.url} target={link?.target}>
						<UI_Icon className={styles.FooterCard_icon} size="sm">
							<UI_Chevron />
						</UI_Icon>
						<span>{link?.name}</span>
					</UI_Link>
				))}
			</div>
		) : null}
	</div>
);
